import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { Tooltip } from '../../../../components/Tooltip';

import { StyledDisclaimer, StyledDisclaimerInfoIcon, StyledDisclaimerLink } from './styles';

const TERMS_URL = 'https://www.similarweb.com/corp/legal/terms';

const DISCLAIMER_TOOLTIP_FALLBACK =
  'SimilarAgents are AI generated tools and outputs which may be inaccurate, incomplete, or reflect unintended bias, ' +
  'so use output with caution. Review results independently before relying on them for professional use. ' +
  'Use of SimilarAgents is subject to the';

export const AIOutreachDisclaimer = () => {
  const { t } = useTranslation();

  const tooltipContent = (
    <>
      {t('company.overview.ai-outreach.disclaimer_tooltip', DISCLAIMER_TOOLTIP_FALLBACK)}{' '}
      <StyledDisclaimerLink href={TERMS_URL} target="_blank" rel="noopener noreferrer">
        {t('company.overview.ai-outreach.terms_link', 'Similarweb AI Agent Terms of Use')}
      </StyledDisclaimerLink>
    </>
  );

  return (
    <StyledDisclaimer data-automation="AIOutreachDisclaimer">
      {t(
        'company.overview.ai-outreach.disclaimer',
        'Our agent can make mistakes. Similarweb only uses shared data to improve your future results and not to train models.'
      )}
      <Tooltip content={tooltipContent} placement="top-left" maxWidth={280}>
        <StyledDisclaimerInfoIcon>
          <SWReactIcons iconName="info" size="xs" iconColor={colorsPalettes.carbon[200]} />
        </StyledDisclaimerInfoIcon>
      </Tooltip>
    </StyledDisclaimer>
  );
};
